<template>
	<c-dialog ref="dialog" :title="title" width="520" height="616" enable-flex :button="false">
		<div class="share-dialog-content flex-column flex-grow">
			<!-- 分享开关 -->
			<div class="share-switch-box flex-center-cross">
				<span class="switch-label">分享开关</span>
				<c-switch v-model="shareEnabled" @change="shareSwitchChange"></c-switch>
			</div>

			<!-- 分享已关闭提示 -->
			<div v-if="!shareEnabled" class="share-closed-tip flex-center flex-grow">
				<p>分享已关闭，开启后可生成分享链接</p>
			</div>

			<!-- 分享内容 -->
			<template v-else>
				<!-- 分享链接地址 -->
				<div class="share-item">
					<label class="share-label">分享链接地址</label>
					<div class="share-link">{{ shareUrl }}</div>
				</div>

				<!-- 密码保护 -->
				<div class="share-item">
					<div class="password-row flex-center-cross">
						<c-checkbox v-model="isPasswordProtected" @change="passwordChangeHandle">密码保护</c-checkbox>
						<template v-if="isPasswordProtected">
							<div class="password-tag">{{ password }}</div>
							<c-link color="main" icon="c-icon-refresh" @click="refreshPassword">重新生成</c-link>
						</template>
					</div>
				</div>

				<div class="share-handle flex">
					<div class="flex-center flex-grow" @click="copyLink"><i class="tf">&#xe8a4;</i>复制分享链接</div>
					<div class="flex-center flex-grow" @click="downloadQrcode"><i class="tf">&#xe692;</i>保存分享二维码</div>
				</div>

				<!-- 二维码展示 -->
				<div class="share-qrcode flex-center">
					<img :src="qrcode" alt="">
				</div>
			</template>
		</div>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'
	import {qrcode} from '@deanwu/vue-component-library'

	export default {
		name: 'shareDialog',

		data() {
			return {
				workType: 0,
				workId: 0,
				workCode: '',
				title: '',				//弹框标题
				qrTitle: '',			//二维码标题
				shareLikeTitle: '',		//分享链接标题
				shareUrl: '',
				qrcode: '',
				token: '',
				password: '',
				isPasswordProtected: true,
				shareEnabled: false
			}
		},

		computed: {
			...mapState(['saasInfo', 'systemConfig'])
		},

		watch: {
			shareUrl(val) {
				val ? this.createQrcode() : (this.qrcode = '');
			}
		},

		methods: {
			open(data) {
				this.resetShareData();
				this.workType = data.workType;
				this.workId = data.workId;
				this.workCode = data.workCode;
				this.title = data.title;
				this.qrTitle = data.qrTitle;
				this.shareLikeTitle = data.shareLikeTitle;
				this.queryStatus();
			},

			// 查询分享状态
			queryStatus() {
				this.request({
					url: '/share/status',
					data: {
						work_type_id: this.workType,
						work_id: this.workId
					},
					loading: true,
					success: data => {
						this.$refs.dialog.open();
						if (data) {
							this.shareEnabled = true
							this.token = data.token
							this.isPasswordProtected = data.isPasswordProtected == 1
							this.password = data.password || ''
							this.buildShareUrl()
							this.$nextTick(() => {
								this.renderQrcode()
							})
						} else {
							this.shareEnabled = false
							this.resetShareData()
						}
					}
				})
			},

			// 分享开关变化
			shareSwitchChange(val) {
				if (val) {
					// 开启分享
					this.request({
						url: '/share/createOrGet',
						data: {
							work_type_id: this.workType,
							work_id: this.workId
						},
						loading: true,
						success: data => {
							this.token = data.token
							this.isPasswordProtected = data.isPasswordProtected == 1
							this.password = data.password || ''
							this.buildShareUrl()
							this.$nextTick(() => {
								this.renderQrcode()
							})
						}
					})
				} else {
					// 关闭分享
					if (!this.token) {
						this.resetShareData()
						return
					}
					this.request({
						url: '/share/close',
						data: { token: this.token },
						success: () => {
							this.resetShareData()
						}
					})
				}
			},

			// 重置分享数据
			resetShareData() {
				this.shareEnabled = false;
				this.token = '';
				this.shareUrl = '';
				this.password = '';
				this.isPasswordProtected = true;
			},

			// 构造分享链接
			buildShareUrl() {
				this.shareUrl = this.systemConfig.system_h5_url + `share/work?token=${this.token}`
			},

			// 渲染二维码到 canvas
			renderQrcode() {
				if (!this.shareUrl || !this.$refs.qrcodeCanvas) return
				QRCode.toCanvas(this.$refs.qrcodeCanvas, this.shareUrl, {
					width: 180,
					margin: 2
				}, (err) => {
					if (err) console.error('二维码生成失败', err)
				})
			},

			// 密码保护开关变化
			passwordChangeHandle(val) {
				const isProtected = val ? 1 : 0
				if (isProtected && !this.password) {
					this.password = this.generateRandomPassword()
				}
				this.request({
					url: '/share/update',
					data: {
						token: this.token,
						is_password_protected: isProtected,
						password: this.password
					}
				})
			},

			// 生成随机密码
			generateRandomPassword() {
				const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
				let pwd = ''
				for (let i = 0; i < 4; i++) {
					pwd += chars.charAt(Math.floor(Math.random() * chars.length))
				}
				return pwd
			},

			// 随机生成密码
			refreshPassword() {
				let password = this.generateRandomPassword()
				this.request({
					url: '/share/update',
					data: {
						token: this.token,
						is_password_protected: 1,
						password: password
					},
					loading: true,
					success: () => {
						this.password = password;
						this.$message({
							message: '密码已重新生成'
						})
					}
				})
			},

			// 复制全部信息
			copyLink() {
				this.$copy([
					`${this.shareLikeTitle}${this.shareUrl}`,
					this.isPasswordProtected ? `访问密码：${this.password}` : ''
				].filter(item => item).join('\n'));
			},

			downloadQrcode() {
				let link = document.createElement('a');
				link.download = `分享-${this.workCode}.png`;
				link.href = this.qrcode;
				link.click();
			},

			// 下载二维码图片
			async createQrcode() {
				let canvas = document.createElement('canvas');
				let width = 1000, height = 880;
				canvas.width = width;
				canvas.height = height;

				let ctx = canvas.getContext('2d');
				ctx.fillStyle = '#fff';
				ctx.fillRect(0, 0, width, height);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'top';

				// 工厂名
				ctx.fillStyle = '#2EBC78';
				ctx.font = 'bold 50px -apple-system, Helvetica, Helvetica Neue, PingFang SC, sans-serif';
				ctx.fillText(this.saasInfo.saas_name, width / 2, 60);

				// 单据号
				ctx.fillStyle = '#333';
				ctx.font = '40px -apple-system, Helvetica, Helvetica Neue, PingFang SC, sans-serif';
				ctx.fillText(this.qrTitle, width / 2, 148);

				// 提示文字
				ctx.fillStyle = '#999';
				ctx.font = '40px -apple-system, Helvetica, Helvetica Neue, PingFang SC, sans-serif';
				ctx.fillText('扫码查看', width / 2, 800);

				// 二维码
				let image = new Image();
				image.src = await qrcode.toDataURL(this.shareUrl, {
					width: 550,
					height: 550,
					margin: 0
				});
				image.onload = () => {
					ctx.drawImage(image, (width - 550) / 2, 220, 550, 550);
					this.qrcode = canvas.toDataURL('image/png');
				};
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.share-dialog-content {
		padding: 18px;
	}

	.share-switch-box {
		margin-bottom: 20px;
		padding: 15px;
		background-color: #f8f8f8;
		border-radius: 8px;
	}

	.switch-label {
		font-size: 14px;
		font-weight: bold;
		color: #333;
		margin-right: 15px;
	}

	.share-closed-tip {
		font-size: 14px;
		color: #999;
	}

	.share-item {
		margin-bottom: 20px;
	}

	.share-label {
		display: block;
		margin-bottom: 10px;
		font-size: 16px;
		color: #333;
	}

	.share-link {
		min-height: 40px;
		padding: 10px 14px;
		border-radius: 4px;
		line-height: 20px;
		font-size: 13px;
		word-break: break-all;
		white-space: normal;
		color: #666;
		background: #F9F9F9;
	}

	.password-row {
		gap: 10px;
		height: 32px;
	}

	.password-tag {
		display: inline-block;
		border: 1px solid #ddd;
		border-radius: 14px;
		padding: 0 16px;
		line-height: 26px;
		font-size: 14px;
		color: #333;
		background: #F9F9F9;
	}

	.share-handle {
		gap: 20px;

		div {
			gap: 6px;
			height: 42px;
			border: 1px solid var(--color-main);
			border-radius: 4px;
			font-size: 16px;
			color: var(--color-main);
			cursor: pointer;

			&:hover {
				color: #fff;
				background: var(--color-main);
			}
		}
	}

	.share-qrcode {
		box-sizing: border-box;
		height: 285px;
		border-radius: 4px;
		padding: 15px;
		margin-top: 15px;
		background-color: #F5F5F5

		img {
			border-radius: 8px;
		}
	}
</style>
